import { useQuery } from '@apollo/client/react';

import { getQuery } from '../../services/PaymentService';

export const usePayment = (paymentId) => {
  const { data, loading, error } = useQuery(getQuery, {
    fetchPolicy: 'cache-and-network',
    variables: { id: paymentId }
  });

  return { payment: data?.payment || null, loading, error };
};
